import * as React from 'react';
import Helmet from 'react-helmet';
import Radium from 'radium';
import { Grid } from 'react-bootstrap';
import { connect } from 'react-redux';

import { acceptCookiePolicy, rejectCookiePolicy } from '../../application/actions';

const mapStateToProps = ({ application: { cookiePolicyState } }) => ({ cookiePolicyState });
const mapDispatchToProps = { acceptCookiePolicy, rejectCookiePolicy };

@Radium
@connect(mapStateToProps, mapDispatchToProps)
export default class PrivacyPolicy extends React.Component {
  render() {
    return (<Grid>
      <Helmet>
        <title>Zásady ochrany osobních údajů</title>
      </Helmet>
      <h1 style={styles.h1}>Zásady ochrany osobních údajů</h1>

      <p>Udělením souhlasu se zpracováním osobních údajů poskytujete souhlas k tomu, aby provozovatel webu Stužák, z.s. (dále jako „Stužák“) zpracovával vaše osobní údaje dle dále uvedených podmínek.</p>

      <h3>Rozsah zpracování vašich osobních údajů</h3>

      <p>Provozovatel Stužák bude vaše osobní údaje zpracovávat v rozsahu, v kterém jste je poskytli při:
      <ol>
        <li>zaregistrování objednávky workshopu ve formuláři na webu provozovatele;</li>
        <li>registraci k newsletteru na webu provozovatele;</li>
        <li>použití kontaktního formuláře;</li>
        <li>objednávce výukových pomůcek.</li>
      </ol></p>

      <p>Stužák zpracovává následující osobní údaje:
      <ol>
        <li>objednávky - jméno, příjmení, e-mail, telefonní číslo;</li>
        <li>registrace k newsletteru - e-mail a volitelně jméno a příjmení;</li>
        <li>kontaktní formulář - e-mail;</li>
        <li>objednávky výukových pomůcek - jméno, příjmení, e-mail, telefonní číslo, adresa.</li>
      </ol></p>

      <h3>Účel zpracování osobních údajů</h3>
      <p>Zpracování osobních údajů probíhá za účelem:
      <ol>
        <li>objednávka – kontaktování za účelem domluvení podrobností ohledně Vašich workshopů;</li>
        <li>registrace k newsletteru – kontaktování za účelem zasílání novinek ohledně Stužáku;</li>
        <li>kontaktní formulář - kontaktování ohledně vašeho dotazu;</li>
        <li>objednávka výukových pomůcek - vyřízení vaší objednávky.</li>
      </ol></p>

      <h3>Právní základ zpracování osobních údajů</h3>
      <p>Právním základem zpracování je váš souhlas s těmito podmínkami. Osobní údaje jsou zpracovávány v souladu s Obecným nařízením o ochraně osobních údajů - Nařízením Evropského parlamentu a rady (EU) 2016/679 ze dne 27.4.2016 (dále jako „GDPR“).</p>

      <h3>Doba zpracování vašich osobních údajů</h3>
      <p>Vaše osobní údaje budou zpracovávány, dokud souhlas neodvoláte.</p>

      <h3>Odvolání souhlasu se zpracováním osobních údajů</h3>
      <p>Váš udělený souhlas se zpracováním osobních údajů můžete kdykoliv odvolat a to pomocí e-mailové žádosti zaslané na adresu <a href="mailto:webmaster@stuzak.cz">webmaster@stuzak.cz</a>.</p>
      <p>V případě newsletteru lze odvolání souhlasu rovněž učinit pomocí odhlašovacího odkazu, který je součástí každého zaslaného newsletteru.</p>

      <h3>Osoby s přístupem k vašim osobním údajům</h3>
      <p>K vašim osobním údajům mají přístup členové správní rady Stužáku, která je sestavena voleným předsedou zapsaného spolku.</p>

      <h3>Kontaktní údaje správce</h3>
      <p>Stužák můžete kontaktovat pomocí e-mailu na adrese <a href="mailto:info@stuzak.cz">info@stuzak.cz</a>.</p>

      <h3>Vaše práva související s ochranou osobních údajů</h3>
      <p>Máte právo svůj souhlas kdykoliv odvolat, opravit či doplnit osobní údaje, požadovat omezení zpracování, vznést námitku či stížnost proti zpracování osobních údajů, požadovat přenesení údajů, být informován o porušení zabezpečení osobních údajů, výmaz a další práva podle GDPR.</p>

      <h3>Právo vznést námitku</h3>
      <p>Máte právo vznést námitku proti zpracování osobních údajů. Námitku je nutné podat na adrese <a href="mailto:webmaster@stuzak.cz">webmaster@stuzak.cz</a>.</p>

      <h3>Právo podat stížnost u dozorového úřadu</h3>
      <p>Máte právo podat stížnost týkající se zpracování vašich osobních údajů nebo neplnění povinností Stužáku plynoucích z GDPR. Dozorovým úřadem v ČR je Úřad pro ochranu osobních údajů, Pplk. Sochora 27, 17000 Praha 7, <a href="https://www.uoou.cz">www.uoou.cz</a>.</p>

      <p>&nbsp;</p>

      <p>Tyto podmínky jsou platné od 24.5.2018.</p>

      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>


    </Grid>);
  }
}

const styles = {
  h1: {
    textAlign: 'center'
  }
};



// WEBPACK FOOTER //
// ./src/browser/Feature/PrivacyPolicy/index.jsx